angular.module('shared').factory('DrawerService', ["$rootScope", "$modal", function($rootScope, $modal) {
  return {
    open: function(params) {
      return $modal.open({
        template: params.template,
        windowClass: 'drawer__wrapper',
        backdropClass: 'modal-backdrop--drawer',
        resolve: params.resolve,
        controller: params.controller
      });
    },
    closeOnRouteChange: function($scope, close) {
      var unsubscribe;
      unsubscribe = $rootScope.$on('$stateChangeSuccess', function() {
        return close();
      });
      return $scope.$on('$destroy', function() {
        return unsubscribe();
      });
    }
  };
}]);
